import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import { AppWithProviders } from './App';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import { installGlobalErrorHandlers } from './services/telemetry';
import './index.css';

installGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <Toaster
            position="top-center"
            toastOptions={{
              duration: 4000,
              style: {
                fontFamily: "'Inter', system-ui, sans-serif",
                fontSize: '14px',
                fontWeight: 500,
                borderRadius: '12px',
                padding: '12px 16px',
              },
              success: { iconTheme: { primary: '#e8374a', secondary: 'white' } },
            }} />

          <ErrorBoundary>
            <AppWithProviders />
          </ErrorBoundary>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
